import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import gameReducers from "../reducers"

export const thunk = createAsyncThunk("game/getGames", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get("/game/")
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

export const onSucceed = gameReducers.setGames

const thunkObject = { thunk, onSucceed }
export default thunkObject
